import { BasicEnumerable } from "../BasicEnumerable.js";
import { ArgumentOutOfRangeException } from "../../shared/index.js";
export const chunk = (source, size) => {
    if (size < 1) {
        throw new ArgumentOutOfRangeException("size");
    }
    function* iterator() {
        let yieldChunk = [];
        for (const value of source) {
            yieldChunk.push(value);
            if (yieldChunk.length === size) {
                yield yieldChunk;
                yieldChunk = [];
            }
        }
        if (yieldChunk.length) {
            yield yieldChunk;
        }
    }
    return new BasicEnumerable(iterator);
};
